package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.GameTableRepository
import kotlinx.coroutines.flow.Flow

class ObserveUserMembershipChangesUseCase(
    private val gameTableRepository: GameTableRepository
) {
    operator fun invoke(userId: String): Flow<Unit> {
        return gameTableRepository.observeUserMembershipChanges(userId)
    }
}
